import {FC} from 'react'

import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {AboutUsStatisticType} from '@/utils/statistics/types'
import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {StatisticItem} from '../common/statistics/StatisticItem'

type AboutUsStatisticsProps = {
  statistics: AboutUsStatisticType[]
}

export const AboutUsStatistics: FC<AboutUsStatisticsProps> = ({statistics}) => {
  const {t} = useTranslation()

  return (
    <>
      <ul className="list">
        {statistics.map(({title, description, imageSrc, imageAlt}) => (
          <li key={description} className="item">
            <StatisticItem
              title={title}
              description={t(description)}
              imageSrc={imageSrc}
              imageAlt={imageAlt}
            />
          </li>
        ))}
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: ${theme.spacing[5.5]};
        }
        .item {
          flex: 1;
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .list {
            justify-content: center;
          }
          .item {
            flex: 0 0 35%;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .item {
            flex: 1 0 100%;
          }
        }
      `}</style>
    </>
  )
}
